module.exports = __webpack_public_path__ + "images/statistics@3x.png?aed031cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/statistics@3x.png
// module id = 709
// module chunks = 7